import { useEffect, useRef, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { api } from '../lib/api';
import { useToast } from '../contexts/ToastContext';

export function VerifyEmailPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { success, error } = useToast();
  const [status, setStatus] = useState<'loading' | 'ok' | 'error'>('loading');
  const token = params.get('token') ?? '';
  const attemptedTokenRef = useRef<string | null>(null);

  useEffect(() => {
    if (attemptedTokenRef.current === token) {
      return;
    }
    attemptedTokenRef.current = token;

    if (!token) {
      setStatus('error');
      error('Verifieringstoken saknas');
      return;
    }
    api.post<{ ok: boolean }>('/auth/verify-email', { token })
      .then(() => {
        setStatus('ok');
        success('E-post verifierad');
        setTimeout(() => navigate('/login', { replace: true }), 800);
      })
      .catch((err) => {
        setStatus('error');
        error(err instanceof Error ? err.message : 'Verifiering misslyckades');
      });
  }, [navigate, token, success, error]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-white p-4">
      <div className="w-full max-w-sm text-center space-y-3">
        <img src="/logga.png" alt="ApisAI" className="h-10 w-auto mx-auto" />
        <h1 className="text-lg font-semibold">Verifiera e-post</h1>
        {status === 'loading' && <p className="text-sm text-gray-600">Verifierar...</p>}
        {status === 'ok' && <p className="text-sm text-gray-600">Klart. Du skickas till login.</p>}
        {status === 'error' && (
          <p className="text-sm text-gray-600">
            Verifiering misslyckades eller länken har gått ut.{' '}
            <Link to="/login" className="text-primary hover:underline">Gå till login</Link>
            {' '}och skicka verifieringsmail igen.
          </p>
        )}
      </div>
    </div>
  );
}

